import { PageLocatorMap } from '../types/PageLocatorMap';

export const loanDocumentUploadAllPage = {
  alert: {
    error: 'loan-document-upload-all.form.alert.error',
  },
  footer: {
    root: 'loan-document-upload-all.footer.root',
  },
  form: {
    exampleGAPLink: 'loan-document-upload-all.form.example-gap-link',
    exampleRICLink: 'loan-document-upload-all.form.example-ric-link',
    exampleRoot: 'loan-document-upload-all.form.example-root',
    exampleVSCLink: 'loan-document-upload-all.form.example-vsc-link',
    h1: 'loan-document-upload-all.form.h1',
    h2: 'loan-document-upload-all.form.h2',
    root: 'loan-document-upload-all.form.root',
    submitButton: 'loan-document-upload-all.form.submit-button',
  },
  header: {
    drawerButton: 'loan-document-upload-all.header.drawer-button',
    previousStepButton: 'loan-document-upload-all.header.previous-step-button',
    root: 'loan-document-upload-all.header.root',
  },
  progress: {
    root: 'loan-document-upload-all.progress.root',
  },
} as const satisfies PageLocatorMap;
